export const TRANSLATIONS_EN = {
 "header.home" : "Home" ,
 "header.admin.signUp": "Sign Up",
 "footer.contactUs": "Contact Us",
 "page.endDate": "End Date",
 "page.login": "Login",
 "page.email": "Email",
 "page.address1": "Address Line1",
 "page.address2": "Address Line2",
 "page.city": "City",
 "page.country": "Country",
 "page.state": "State",
 "page.zipCode": "Zip Code",
 "page.zipExt": "Zip Extn",
 "page.phone": "Phone",
 "page.manageMFA.token":"Token is required.",
 "page.MFAModel.header":"Provide Multi-factor authentication token from Authenticator App",
 "page.MFAModel.token":"Token",
 "page.MFAModel.reset":"Reset Multi-factor Auth",
 "page.forgotPasswd.toResetPassword":"To reset the password",
 "page.forgotPasswd.step1":"1. Request for a verification code which will be sent to your email id.",
 "page.forgotPasswd.step2":"2. Input the verification code received along with the new password in the fields below and submit the request.",
 "page.forgotPasswd.step1.1":"Step 1. Provide the registered email id to generate a verification code.",
 "page.forgotPasswd.step1.2":"Please check your email for the verification code after you submit the request.",
 "page.forgotPasswd.step2.1":"Step 2. Input the emailed verification code and new password in the fields below and submit the request.",
 "page.forgotPasswd.verificationCode":"Verification Code",
 "page.verification.verifyAccount":"Verify your Account",
 "page.verification.checkEmail":"Please check your registered email for the verification code.",
 "page.resendCode.resend":"Resend Verification Code",
 "page.login.forgotPassword":"Forgot Password",
 "page.company": "Company",
 "page.firstName": "First Name",
 "page.lastName": "Last Name",
 "page.submit": "Submit",
 "page.cancel": "Cancel",
 "page.password": "Password",
 "header.report.suggest": "Report an incident",
 "page.name": "Name",
 "page.suggest.desc": "Incident description and sources",
 "info.addSuggest":"Your incident suggestion was successfully sent.",
 "page.search": "Search",
 "page.advancedsearch": "Advanced Search",
 "page.clear": "Clear",
 "page.page": "Page",
 "page.goToPage": "Go to page",
 "page.of": "of",
 "page.open": "open",
 "page.close":"Close",
 "page.incidentSumm":"Incident Summary",
 "page.incidentType":"Incident Type",
 "page.ptIntro":"Point of Introduction",
 "page.harmType":"Type(s) of Harm",
 "page.ptIntroDesc":"Description of Point of Introduction",
 "page.harmDesc":"Description of Harm",
 "page.harmLoc":"Harm Location(s)",
 "page.numIll":"Number of Illnesses",
 "page.numDeath":"Number of Deaths",
 "page.motivation":"Motivation",
 "page.motivationDesc":"Description of Motivation",
 "page.primMethodAdu":"Primary Method of Adulteration",
 "page.secMethodAdu": "Secondary Method(s) of Adulteration",
 "page.numRef":"Number of References",
 "page.consumerBrand":"Consumer Brand(s)",
 "page.affFoodProd":"Affected Food Product(s)",
 "page.qtyAdulterant":"Quantity of Adulterant Used",
 "page.longTermImpact":"Long Term Impact",
 "page.history":"History",
 "page.citation":"Citation(s)",
 "page.authors":"Authors",
 "page.date":"Date",
 "page.title":"Title",
 "page.source":"Source",
 "page.volume":"Volume",
 "page.foodCat":"Food Category",
 "page.yearBegan":"Year Began",
 "page.yearEnded":"Year Ended",
 "page.aduFoodProd":"Adulterated Food Product(s)",
 "page.adulterant":"Adulterant(s)",
 "page.methodAdu":"Method of Adulteration",
 "page.origLoc":"Originated Location(s)",
 "page.action": "Action",
 "page.confirmationMessage": "Are you sure?",
   
 "error.MFATokenError": "Error!! Multi-factor Authentication token provided is not valid.",
 "error.getParamFailed":"Error!! Search Parameters was not retrieved",
 "error.searchFailed":"Error!! Event list was not retrieved",
 "error.minSearchParam":"If no search text  is provied or if search text is less then 3 characters, then at least one advanced search parameters should be provided.",
 "error.error":"Error!!",
 "error.userAuthFailed":"User Authentication Failed.",
 "error.emailReqd":"Email is required.",
 "error.invalidEmail":"Please provide a valid email id!",
 "error.passwdReqd":"Password is required.",
 "error.weakPassword":"Please choose a strong password with minimum 8 characters, a number and a special character!",
 "error.MFAAuthFailed": "Error!! Multi-factor Authentication failed ",
 "error.MFAStateError": "Error!! There was error in changing the MFA state.",
 "error.passwdMatchFailed":"Passwords doesn't match!",
 "error.termsUpdateFailed": "Error!! Terms and condition update failed.",
 "error.retypePasswdReqd":"Retype Password is required!",
 "error.sendCodeError":"Error!! Sending verification code for resetting the password failed. Please try again later",
 "error.codeReqd":"Verification Code is required.",
 "error.verificationFailed":"Error!! Verification failed. Please try again later",
 "error.changePasswordFailed":"Error!! Password change failed. Please try again later",
 "error.resendVerificationFailed":"Error!! Resend verification code failed. Please try again later",
 "error.userNameReqd":"Username is required.",
 "error.firstNameReqd":"First name is required.",
 "error.lastNameReqd":"Last name is required.",
 "error.compNameReqd":"Company name is required.",
 "error.stateReqd":"State is required.",
 "error.userEditFailed":"Customer information was not updated",
 "error.addUserFailed":"Add user failed.",
 "error.phoneReqd":"Phone is required.",
 "error.phoneEmailReqd":"Phone or Email is required.",
 "error.descReqd":"Description is required.",
 "error.addSuggestFailed":"There was a problem sending your incident suggestion.",
 "error.unhandledException":"Unhandled action type",
 "error.getCountryFailed":"Error!! Country list was not retrieved",
 "error.getStateFailed":"State list was not retrieved",
 "error.sessionTimeout":"Session has timed out. Please login again.",
 "error.logoutFailed":"Logout Failed.",
};